/* eslint-disable */
import { useState, useEffect } from "react";
import { useCalendar } from "./useCalendar";
import { ICalendarItem } from "../types";
import { useHookSubscribe } from "../../../hooks/hookSubscribe"

export function useCalendarItems(): [ICalendarItem[] | null, (val: ICalendarItem[] | null) => void ] {
  const context = useCalendar();
  const value = useHookSubscribe(context.currentItems, context.items);

  const setContextValue = (val: ICalendarItem[] | null) => {
    context.setItems(val);
  }
  return [value, setContextValue];
}
